<template>
  <div class="imagePreviewWrapper">
    <img
      :src="src"
      :alt="alt"
      :height="height"
      :width="width"
      :class="newClass"
      @error="setAltImg"
    >
    <feather-icon
      icon="ZoomInIcon"
      class="imagePreviewIcon"
      @click="modalShow = !modalShow"
    />
    <b-modal
      id="image_preview_modal"
      v-model="modalShow"
      hide-footer
      centered
      size="lg"
    >
      <img :src="src">
    </b-modal>
  </div>
</template>

<script>
import noImage from '@/assets/images/pages/no-image.png'

export default {
  name: 'ImgWithNoImageError',
  props: {
    src: {
      type: String,
      required: true,
      default: noImage,
    },
    height: {
      type: String,
      default: '30px',
    },
    width: {
      type: String,
      default: '30px',
    },
    alt: {
      type: String,
      required: false,
    },
    newClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalShow: false,
    }
  },
  methods: {
    setAltImg(event) {
      const image = event.target
      image.src = noImage
      image.alt = 'no-image'
    },
  },
}
</script>
